define('meetings/lib/share-meeting/share-meeting',['require','exports','module','durandal/app','knockout','lodash','plugins/dialog','api-access','api-access','dialog-helper/responsive','web-urls','i18next','moment','api-access','api-access','zero-clipboard-binding','swfobject','web-urls'],function (require, exports, module) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var _ = require('lodash');
    var dialog = require('plugins/dialog');
    var meetingsApi = require('api-access').meetings;
    var userApi = require('api-access').user;
    var responsiveDialog = require('dialog-helper/responsive');
    var meetingFrontEndSvcUrl = require('web-urls').get('meetingFrontEndSvcUrl');
    var i18n = require('i18next');
    var moment = require('moment');
    var gotomeet = require('api-access').gotomeet;
    var commerceApi = require('api-access').commerce;
    var modalVisibilityWatcher;

    require('zero-clipboard-binding');
    var swfobject = require('swfobject');
    /* global swfobject */

    var ShareMeeting = function (meetingId, banner) {
        var self = this;

        self.meetingId = ko.observable(meetingId);
        self.meetingSettings = ko.observable();
        self.meetingFrontEndSvcUrl = ko.observable(meetingFrontEndSvcUrl);
        self.userSettings = ko.observable();
        self.useAmPm = ko.observable(i18n.t('web-technical.useAmPm'));
        self.joinInstructions = ko.observable();
        self.gotoMeetMe = ko.observable();
        self.joinUrl = ko.observable();
        self.primarynumber = ko.observable();
        self.secondarynumbers = ko.observable();
        self.selectAllClicked = ko.observable();
        self.passwordText = ko.observable('');
        self.meetingPasswordRequired = ko.observable();
        self.passwordValidated = ko.observable(false);
        self.passwordInvalidated = ko.observable();
        self.isPasswordTextEntered = ko.observable();

        self.gotomeetMeUrl = require('web-urls').get('gotoMeetMeUrl');

        self.hasFlash = function () {
            return swfobject.hasFlashPlayerVersion('10');
        };
        self.dateString = ko.observable();

        self.hasCSSAnimations = function () {
            // check if the browser has CSS animations to determine
            // if should fall back to select all option
            return window.Modernizr.cssanimations;
        };

        self.formattedMeetingId = ko.computed(function () {
            if (self.meetingSettings()) {
                return String((self.meetingSettings().meetingId || '')).replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');
            }
            return undefined;
        });

        // optional success banner for share meeting
        // banner argument should be supplied as an object
        // e.g. { text: 'Success!' }, where the text key is what will
        // display in the banner
        self.banner = ko.observable(banner || false);

        self.selectText = function (element) {
            app.trigger('inviteModal:selectedText');
            var doc = document;
            var text = doc.getElementById(element);
            var range;
            var selection;
            if (self.passwordValidated()) {
                self.selectAllClicked(true);
                if (doc.body.createTextRange) {
                    range = document.body.createTextRange();
                    range.moveToElementText(text);
                    range.select();
                } else if (window.getSelection) {
                    selection = window.getSelection();
                    range = document.createRange();
                    range.selectNodeContents(text);
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            } else {
                self.passwordInvalidated(!self.passwordValidated());
                self.focusPasswordField();
            }
        };

        self.show = function () {
            return dialog.show(new ShareMeeting(self.meetingId()));
        };

        self.skip = function () {
            app.trigger('get:meetings');
            dialog.close(self);
        };

        self.reload = function () {
            location.reload();
        };

        self.sortNumbers = function (result, billingCountry) {
            var tollFreeCountriesArray = _.pluck(_.where(result, {tollFree: true}), 'country');
            var tollCountriesArray = _.pluck(_.where(result, {tollFree: false}), 'country');
            var preferredResult =
                tollCountriesArray.indexOf(self.userSettings().audio.preferredTollCountry) > -1 ||
                tollFreeCountriesArray.indexOf(self.userSettings().audio.preferredTollFreeCountry) > -1;

            _.forEach(result, function (number) {
                number.countryName = i18n.t('countries.' + number.country);
                if ((number.country === self.userSettings().audio.preferredTollCountry && !number.tollFree) ||
                    (number.country === self.userSettings().audio.preferredTollFreeCountry && number.tollFree)) {
                    number.preferred = true;
                }

                if ((!self.userSettings().audio.preferredTollCountry &&
                    !self.userSettings().audio.preferredTollFreeCountry) || !preferredResult) {
                    if (number.country === billingCountry) {
                        number.alternate = true;
                    }
                }
            });

            // 3. sort by country name
            result.sort(function (x, y) {
                // if there is a pref
                if (x.preferred === true && y.preferred === true) {
                    return x.tollFree ? -1 : 1;
                } else if (x.preferred) {
                    return -1;
                } else if (y.preferred) {
                    return 1;
                } else if (x.alternate === true && y.alternate === true) {
                    return x.alternate ? -1 : 1;
                } else if (x.alternate) {
                    return -1;
                } else if (y.alternate) {
                    return 1;
                } else if (x.country === 'US') { // sort for US
                    return -1;
                } else if (y.country === 'US') {
                    return 1;
                } else if (x.countryName > y.countryName) { // sort the rest of list by alpha
                    return 1;
                } else if (x.countryName < y.countryName) {
                    return -1;
                }

                // x.countryName === y.countryName
                return x.tollFree ? -1 : 1;
            });

            return result;
        };

        self.setNumbers = function (result) {
            var primary = [];
            var secondary = [];

            result.forEach(function (number) {
                if (number.preferred === true) {
                    primary.push(number);
                } else if (primary.length === 0 && number.alternate === true) {
                    primary.push(number);
                } else if (primary.length === 0) {
                    primary.push(number);
                } else if (primary.length === 1 && primary[0].countryName === number.countryName) {
                    primary.push(number);
                } else if (primary.length > 0) {
                    secondary.push(number);
                }
            });

            self.primarynumber(primary);
            self.secondarynumbers(secondary);
        };

        self.getNumbers = function () {
            var result = [];
            if (self.meetingSettings() && self.meetingSettings().audio.audioType !== 'private') {
                // populate numbers
                _.forEach(self.meetingSettings().audio.phoneNumbers, function (number) {
                    result.push(number);
                });

                // get location data from commerce and sort data
                userApi.me().then(function () {
                    commerceApi.getBilling().then(function (billingData) {
                        self.setNumbers(self.sortNumbers(result, billingData.country));
                    }).fail(function () {
                        self.setNumbers(self.sortNumbers(result, 'US'));
                    });
                });
            }
        };

        self.getUserSettings = function () {
            userApi.settings()
                .then(function (data) {
                    self.userSettings(data);
                });
        };

        self.getJoinUrl = function () {
            if (self.gotoMeetMe() && self.gotoMeetMe().meetingId === self.meetingId()) {
                self.joinUrl(self.gotomeetMeUrl + '/' + self.gotoMeetMe().profileId);
            } else {
                self.joinUrl(meetingFrontEndSvcUrl + '/join/' + self.meetingSettings().meetingId);
            }
        };

        self.activate = function () {
            window.mixpanel.track('Open Share Meeting Modal');
            self.getUserSettings();
            return meetingsApi.byIdFormatted(self.meetingId())
                .then(function (data) {
                    self.meetingSettings(data);
                    self.getNumbers();
                    gotomeet.getByUserKey().then(function (dataResponse) {
                        self.gotoMeetMe(dataResponse);
                        self.getJoinUrl();
                    })
                    .fail(function () {
                        self.getJoinUrl();
                    });
                })
                .then(function () {
                    if (self.meetingSettings().meetingType !== 'recurring') {
                        self.dateString = self.meetingSettings().timeStrings.meetingDate + ', ' +
                        self.meetingSettings().timeStrings.meetingStartYear + ' ';

                        if (self.useAmPm() === 'false') {
                            if (self.meetingSettings().timeStrings) {
                                self.meetingSettings().timeStrings.meetingStartTime24 =
                                    moment(self.meetingSettings().timeStrings.meetingStartTime + ' ' +
                                    self.meetingSettings().timeStrings.meetingStartPeriod, 'hh:mm a').format('HH:mm');

                                self.meetingSettings().timeStrings.meetingEndTime24 =
                                    moment(self.meetingSettings().timeStrings.meetingEndTime + ' ' +
                                    self.meetingSettings().timeStrings.meetingEndPeriod, 'hh:mm a').format('HH:mm');

                                self.dateString = self.dateString +
                                    self.meetingSettings().timeStrings.meetingStartTime24 + ' - ' +
                                    self.meetingSettings().timeStrings.meetingEndTime24 + ' ' +
                                    self.meetingSettings().timeStrings.meetingTimeZone;
                            }
                        } else {
                            self.dateString = self.dateString + self.meetingSettings().timeStrings.meetingStartTime +
                                ' ' + self.meetingSettings().timeStrings.meetingStartPeriod + ' - ' +
                                self.meetingSettings().timeStrings.meetingEndTime +
                                ' ' + self.meetingSettings().timeStrings.meetingEndPeriod + ' ' +
                                self.meetingSettings().timeStrings.meetingTimeZone;
                        }
                        if (self.meetingSettings().nativeEndpointDisabled) {
                            self.joinInstructions(i18n.t('share.join.instructions.instantJoinEndpoint'));
                        } else {
                            self.joinInstructions(i18n.t('share.join.instructions.anyEndpoint'));
                        }
                    } else {
                        if (self.meetingSettings().nativeEndpointDisabled) {
                            self.joinInstructions(i18n.t('share.join.instructions.instantJoinEndpoint'));
                        } else {
                            self.joinInstructions(i18n.t('share.join.instructions.anyEndpoint'));
                        }
                    }
                    self.meetingPasswordRequired(self.meetingSettings().passwordRequired);
                });
        };

        self.compositionComplete = function (child) {
            responsiveDialog(self, child);

            /* This needs to be done, to make sure the settings dialog is centered properly. */
            (function waitForVisibleModal() {
                var shareMeetingModal = $('.modal-content.share-meeting');
                if (shareMeetingModal.length > 0 && $(shareMeetingModal[0]).css('visibility') !== 'visible') {
                    modalVisibilityWatcher = setTimeout(waitForVisibleModal, 500);
                } else {
                    app.trigger('inviteModal:shown');
                    if (modalVisibilityWatcher) {
                        clearTimeout(modalVisibilityWatcher);
                    }
                    var shareMeetingPasswordField = $('#shareMeetingPasswordField');
                    if (self.meetingPasswordRequired() && shareMeetingPasswordField) {
                        $(shareMeetingPasswordField).keyup(function (event) {
                            self.passwordInvalidated(!event.target.value);
                        });
                        $(shareMeetingPasswordField).focusout(function () {
                            $(shareMeetingPasswordField).popover('hide');
                        });
                        $(shareMeetingPasswordField).focus(function () {
                            // had to do this because of the event sequence when clicked rapidly
                            setTimeout(function () { $(shareMeetingPasswordField).popover('show') }, 100);
                        });
                        self.focusPasswordField();
                    }
                }
            }());
        };

        self.focusPasswordField = function () {
            if (self.meetingPasswordRequired()) {
                var shareMeetingPasswordField = $('#shareMeetingPasswordField');
                if (shareMeetingPasswordField) {
                    $(shareMeetingPasswordField).focus();
                }
            }
        };

        self.passwordValidated = ko.computed(function () {
            // if meeting password required then has password text been entered else always true
            return !self.meetingPasswordRequired() || self.isPasswordTextEntered();
        });

        self.isPasswordTextEntered = ko.computed(function () {
            return self.passwordText().trim();
        });

        self.copyClick = function () {
            app.trigger('inviteModal:copiedText');
            self.passwordInvalidated(!self.passwordValidated());
            if (self.passwordInvalidated()) {
                self.focusPasswordField();
            }
        };
    };

    module.exports = ShareMeeting;
});

